import Rails from '@rails/ujs';
Rails.start();

import Turbolinks from 'turbolinks';
Turbolinks.start();

import './global-jquery';
import 'bootstrap';
import 'bootstrap-tab-history';

import './features/companyForm';
import './features/signIn';
import './features/validation';
import './overrides';

// Stimulus
import { Application } from 'stimulus';
import AutocompleteController from './controllers/AutocompleteController';
import CompanyFormController from './controllers/CompanyFormController';
import OrderlineController from './controllers/OrderlineController';
import OrderlinesController from './controllers/OrderlinesController';
import PlanFormController from './controllers/PlanFormController';
import SignupFormController from './controllers/SignupFormController';
import CopyToClipboardController from './controllers/CopyToClipboardController';
import SettingsToggleController from './controllers/SettingsToggleController';
const application = Application.start();
application.register('autocomplete', AutocompleteController);
application.register('copy-to-clipboard', CopyToClipboardController);
application.register('company-form', CompanyFormController);
application.register('orderline', OrderlineController);
application.register('orderlines', OrderlinesController);
application.register('plan-form', PlanFormController);
application.register('signup-form', SignupFormController);
application.register('settings-toggle', SettingsToggleController);
